export default function MedalIcon(props) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_3535_2076)">
        <path
          d="M9.99935 12.4999C13.221 12.4999 15.8327 9.88825 15.8327 6.66659C15.8327 3.44492 13.221 0.833252 9.99935 0.833252C6.77769 0.833252 4.16602 3.44492 4.16602 6.66659C4.16602 9.88825 6.77769 12.4999 9.99935 12.4999Z"
          stroke="inherit"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.84232 11.575L5.83398 19.1666L10.0007 16.6666L14.1673 19.1666L13.159 11.5667"
          stroke="inherit"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3535_2076">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
